import { handleRepulsion, getIconPosition, getCompassAngle } from "./swell-helpers"

import SwellIcon from "components/swell-icon/swell-icon"
import Units from "utils/units"
import createStarRating from "components/star-rating"

export function createSwellMap(data, rating, windState) {
  const mapContainer = document.createElement("div")
  mapContainer.className = "swell-tooltip__map"

  const mapImage = document.createElement("img")
  mapImage.src = `https://www.surf-forecast.com/leaflet_screenshots/${window.FCGON.filename_part}--1200x1200.jpg`
  mapImage.className = "swell-tooltip__map-background"
  mapImage.onerror = () => {
    mapContainer.innerHTML =
      '<div style="color: #666; font-size: 14px; text-align: center; padding: 20px;">Map not available</div>'
  }
  mapContainer.appendChild(mapImage)

  const adjustedSwells = handleRepulsion(data)

  const offshoreDirection = window.FCGON.offshore || null

  if (rating && rating !== "null" && rating !== "undefined") {
    const starRatingContainer = document.createElement("div")
    starRatingContainer.className = "swell-tooltip__star-rating"

    const starRating = createStarRating({
      size: 35,
      rating: parseInt(rating, 10),
      windState: windState.text,
    })

    starRatingContainer.appendChild(starRating)
    mapContainer.appendChild(starRatingContainer)
  }

  adjustedSwells
    .filter((item) => item)
    .sort((a, b) => a.height - b.height)
    .forEach((item) => {
      const swellIconContainer = document.createElement("div")
      swellIconContainer.className = "swell-tooltip__swell-icon"

      const isSheltered = item.height < 0

      const swellPosition = getIconPosition(item.positionAngle, isSheltered)
      swellIconContainer.style.top = `${swellPosition.top}px`
      swellIconContainer.style.right = `${swellPosition.right}px`

      const swellIcon = new SwellIcon({ units: Units })
      swellIcon.update(item)
      swellIcon.el.className = "swell-tooltip__swell-icon-element"

      if (isSheltered) {
        swellIconContainer.classList.add("swell-tooltip__swell-icon--sheltered")
      }

      swellIconContainer.appendChild(swellIcon.el)
      mapContainer.appendChild(swellIconContainer)
    })

  return mapContainer
}
